(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ji-fiji-ticket"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jft-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-jft-copy') || '';
    var original = btn.textContent;
    var restore = function () {
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = original; }, 1600);
    };
    var fallback = function (text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(restore).catch(function () { fallback(code); restore(); });
    } else {
      fallback(code);
      restore();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
